import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import vuexStore from "@/store/vuex-store";
import { CompanySpecialConfig } from "@/lib/model/exam/candidate-answer";
import VUEAPP from "vue";

export class Qr extends Model {
  linkImage = "";
  static getQrImage(link: string) {
    return request
      .post("onlineExam/common/qrCode", { content: link })
      .then(resp => {
        if (parseInt(resp.data.code) === 0) {
          return new Qr().assign({
            linkImage: "data:image/png;base64," + resp.data.data.base64string
          });
        } else {
          return new Qr();
        }
      });
  }
}

export class AP extends Model {
  createPerson = true; //创建候选人
  link = true; //展示考试链接
}
export class BP extends Model {
  judge = true; //阅卷
  reInvite = true; //复邀
  createPerson = true;
  delete = true;
  link = true;
}
export class CP extends Model {
  edit = true; //编辑题目
}
export class DP extends Model {
  base = true; //基础信息
  other = true; //其他信息
  result = true; //查看结果
}
export class EP extends Model {
  edit = true; //编辑面试
}
export class FP extends Model {
  exec = true; //导出
}
export class GP extends Model {
  edit = true; //阅卷
}
export class HP extends Model {
  edit = true; //编辑题目
  link = true; //消息管理的
  result = true; //面试结果通知
}
export class IP extends Model {
  list = true; //
}
export class AiPermission extends Model {
  interview = new AP();
  person = new BP();
  question = new CP();
  candidateInfo = new DP();
  exam = new EP();
  export = new FP();
  judge = new GP();
  message = new HP();
  questionInfo = new IP();
}
//权限对照
// Exam struct {
//   Edit bool `json:"edit"` // 新建/编辑/复制/删除面试
// } `json:"exam"` // 面试管理
// Interview struct {
//   CreatePerson bool `json:"createPerson"` // 添加候选人
//   Link         bool `json:"link"`         // 面试链接
// } `json:"interview"` // 面试管理(旧)-仅冗余
// Person struct {
//   CreatePerson bool `json:"createPerson"` // 添加候选人
//   Link         bool `json:"link"`         // 面试链接
//   ReInvite     bool `json:"reInvite"`     // 邀请重面
//   Judge        bool `json:"judge"`        // 评估候选人
//   Delete       bool `json:"delete"`       // 删除候选人
// } `json:"person"` // 候选人管理
// Question struct {
//   Edit bool `json:"edit"` // 新建/修改/删除题目
// } `json:"question"` // 题目管理
// Export struct {
//   Exec bool `json:"exec"` // 新建/下载导出数据
// } `json:"export"` // 数据导出
// Message struct {
//   Edit bool `json:"edit"` // 创建/修改/删除模板
//   Link bool `json:"link"` // 配置面试消息模板
// } `json:"message"` // 消息管理
// Judge struct {
//   Edit bool `json:"edit"` // 新建/修改/删除面试官
// } `json:"judge"` // 面试官管理
// CandidateInfo struct {
//   Result bool `json:"result"` // 面试结果
//   Other  bool `json:"other"`  // 其他信息
// } `json:"candidateInfo"` // 候选人信息
// QuestionInfo struct {
//   List bool `json:"list"` // 查看题库
// } `json:"questionInfo"` // 题目信息
// } `json:"ai"` // AI面试
export class AiPower extends Model {
  ai = new AiPermission();
}
//用户权限
export class Permission extends Model {
  isHrMark = 0; //数据标注权限 1有
  accountPower = new AiPower();
  companySpecialConfig = new CompanySpecialConfig();
  static getPermission(p = {}) {
    p = { ...p, examType: vuexStore.getExamType };
    //  /aiExam/company/getUserConfig
    return request.post("/aiExam/auditPublic/getUserConfig", p).then(resp => {
      return new Permission().assign(resp.data.data);
    });
  }
  //用户按钮权限
  static getPerm() {
    return Permission.getPermission().then((res: any) => {
      const map = res.accountPower;
      vuexStore.updatePermission(map.ai);
      VUEAPP.prototype.$P = map.ai;
      return res;
    });
  }
}
